import React, { useEffect, useState } from "react";
import FeedbackEditActionModalPresenter from "./FeedbackEditActionModalPresenter";
import DTOFeedbackEditActionModal from "./DTOFeedbackEditActionModal";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const FeedbackEditActionModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOFeedbackEditActionModal />

      <FeedbackEditActionModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default FeedbackEditActionModalController;
